module.exports = __webpack_public_path__ + "img/2.37ea608f.svg";